const map = {
	"./AngloAmerican.png": 51410,
	"./Baxter.png": 29845,
	"./Bunzl.png": 92706,
	"./CAT.png": 14911,
	"./CNH.png": 22134,
	"./CompassGroup.png": 11114,
	"./Delaval.png": 59666,
	"./Dormakaba.png": 42941,
	"./EGA.png": 32562,
	"./Loancare.png": 84770,
	"./Merck.png": 32717,
	"./MiTek.png": 10885,
	"./Monsanto.png": 30536,
	"./Polaris.png": 72711,
	"./RLUS.png": 9193,
	"./SLB.png": 50374,
	"./SMEAD.png": 84161,
	"./Traffix.png": 26643,
	"./Travelers.png": 33003,
	"./Webjet.png": 13868,
	"./basamh.png": 85871,
	"./donaldson.png": 41299,
	"./onco360.png": 19041,
	"./utimco.png": 31496
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60769;